<script>

    import { toast } from 'bulma-toast'
    import { creditStore, creditsStore, modalStore } from '../stores'

    import CreditsService from '../$services/credits.service'

    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'
    import Form from '../$components/form.svelte'

    import Button from '../$components/button.svelte'
    import ButtonModal from '../$components/button.modal.svelte'

    let data = {
        status: $creditStore.status,
        reference: $creditStore.reference,
    }

    let loading = false

    async function updateCredit() {

        loading = true
        const resp = await CreditsService.updateCredit($creditStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        creditsStore.replace(resp.data)
        creditStore.set(resp.data)

        toast({message: 'Crédito actualizado', type: 'is-success'})
        modalStore.set('credit_modal')
    }

</script>

<Form on:submit={updateCredit} { loading } >

    <Select bind:value={data.status}
        label="Estatus"
        options={[
            {value: 'pending', text: 'Pendiente'},
            {value: 'paid', text: 'Pagado'},
            {value: 'free', text: 'Gratis'},
        ]}
    />

    <InputText bind:value={data.reference} label="Referencia" placeholder="Referencia" />

    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="credit_modal" text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>